import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _inherits from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import _regeneratorRuntime from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/regenerator";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { CancellationToken } from '../../../base/common/cancellation.js';
import { onUnexpectedExternalError } from '../../../base/common/errors.js';
import { URI } from '../../../base/common/uri.js';
import { Range } from '../../common/core/range.js';
import { LinkProviderRegistry } from '../../common/modes.js';
import { IModelService } from '../../common/services/modelService.js';
import { CommandsRegistry } from '../../../platform/commands/common/commands.js';
import { isDisposable, Disposable } from '../../../base/common/lifecycle.js';
import { coalesce } from '../../../base/common/arrays.js';
export var Link = /*#__PURE__*/function () {
  function Link(link, provider) {
    _classCallCheck(this, Link);

    this._link = link;
    this._provider = provider;
  }

  _createClass(Link, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        range: this.range,
        url: this.url,
        tooltip: this.tooltip
      };
    }
  }, {
    key: "range",
    get: function get() {
      return this._link.range;
    }
  }, {
    key: "url",
    get: function get() {
      return this._link.url;
    }
  }, {
    key: "tooltip",
    get: function get() {
      return this._link.tooltip;
    }
  }, {
    key: "resolve",
    value: function resolve(token) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this._link.url) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", this._link.url);

              case 2:
                if (!(typeof this._provider.resolveLink === 'function')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(this._provider.resolveLink(this._link, token)).then(function (value) {
                  _this._link = value || _this._link;

                  if (_this._link.url) {
                    // recurse
                    return _this.resolve(token);
                  }

                  return Promise.reject(new Error('missing'));
                }));

              case 4:
                return _context.abrupt("return", Promise.reject(new Error('missing')));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }]);

  return Link;
}();
export var LinksList = /*#__PURE__*/function (_Disposable) {
  _inherits(LinksList, _Disposable);

  var _super = _createSuper(LinksList);

  function LinksList(tuples) {
    var _this2;

    _classCallCheck(this, LinksList);

    _this2 = _super.call(this);
    var links = [];

    var _iterator = _createForOfIteratorHelper(tuples),
        _step;

    try {
      var _loop = function _loop() {
        var _step$value = _slicedToArray(_step.value, 2),
            list = _step$value[0],
            provider = _step$value[1];

        // merge all links
        var newLinks = list.links.map(function (link) {
          return new Link(link, provider);
        });
        links = LinksList._union(links, newLinks); // register disposables

        if (isDisposable(list)) {
          _this2._register(list);
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    _this2.links = links;
    return _this2;
  }

  _createClass(LinksList, null, [{
    key: "_union",
    value: function _union(oldLinks, newLinks) {
      // reunite oldLinks with newLinks and remove duplicates
      var result = [];
      var oldIndex;
      var oldLen;
      var newIndex;
      var newLen;

      for (oldIndex = 0, newIndex = 0, oldLen = oldLinks.length, newLen = newLinks.length; oldIndex < oldLen && newIndex < newLen;) {
        var oldLink = oldLinks[oldIndex];
        var newLink = newLinks[newIndex];

        if (Range.areIntersectingOrTouching(oldLink.range, newLink.range)) {
          // Remove the oldLink
          oldIndex++;
          continue;
        }

        var comparisonResult = Range.compareRangesUsingStarts(oldLink.range, newLink.range);

        if (comparisonResult < 0) {
          // oldLink is before
          result.push(oldLink);
          oldIndex++;
        } else {
          // newLink is before
          result.push(newLink);
          newIndex++;
        }
      }

      for (; oldIndex < oldLen; oldIndex++) {
        result.push(oldLinks[oldIndex]);
      }

      for (; newIndex < newLen; newIndex++) {
        result.push(newLinks[newIndex]);
      }

      return result;
    }
  }]);

  return LinksList;
}(Disposable);
export function getLinks(model, token) {
  var lists = []; // ask all providers for links in parallel

  var promises = LinkProviderRegistry.ordered(model).reverse().map(function (provider, i) {
    return Promise.resolve(provider.provideLinks(model, token)).then(function (result) {
      if (result) {
        lists[i] = [result, provider];
      }
    }, onUnexpectedExternalError);
  });
  return Promise.all(promises).then(function () {
    var result = new LinksList(coalesce(lists));

    if (!token.isCancellationRequested) {
      return result;
    }

    result.dispose();
    return new LinksList([]);
  });
}
CommandsRegistry.registerCommand('_executeLinkProvider', function (accessor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var uri, model, list, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            uri = args[0];

            if (uri instanceof URI) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", []);

          case 3:
            model = accessor.get(IModelService).getModel(uri);

            if (model) {
              _context2.next = 6;
              break;
            }

            return _context2.abrupt("return", []);

          case 6:
            _context2.next = 8;
            return getLinks(model, CancellationToken.None);

          case 8:
            list = _context2.sent;

            if (list) {
              _context2.next = 11;
              break;
            }

            return _context2.abrupt("return", []);

          case 11:
            result = list.links.slice(0);
            list.dispose();
            return _context2.abrupt("return", result);

          case 14:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
});